import { createAsyncThunk } from '@reduxjs/toolkit';
import getCredentials from '../../utils/getCredentials';
import setEditOrientationFormTemplate from 'scenes/ProjectForms/utils/setEditOrientationFormTemplate';

export const editOrientationFormTemplate = createAsyncThunk(
    'projectForm/editOrientationFormTemplate',
    async (data, { getState }) => {
        const { accessKeyId, secretAccessKey, sessionToken } =
            await getCredentials();

        const params = {
            accessKeyId,
            secretAccessKey,
            sessionToken,
        };

        const editedFormTemplate = await setEditOrientationFormTemplate(data, params);
        return { editedFormTemplate };
    }
);